import { AppBar, Box, Button, Toolbar, Typography } from "@mui/material"
import React, { useEffect } from "react"
import { useIsAuthenticated, useSignOut, useAuthUser } from "react-auth-kit"
import { Link, useNavigate, useLocation } from "react-router-dom"
import { styled } from "@mui/material/styles"
import api from "../utils/api"

const CustomButton = styled(Button)({
  textDecoration: "none",
  color: "white",
  "&:hover": {
    backgroundColor: "transparent",
  },
})

export function Header() {
  const navigate = useNavigate()
  const location = useLocation()
  const isAuthenticated = useIsAuthenticated()
  const signOut = useSignOut()
  const auth = useAuthUser()

  // Handle browser close events
  useEffect(() => {
    const handleBeforeUnload = async () => {
      // Check if user is authenticated
      if (isAuthenticated() && auth()) {
        const userData = auth();
        if (userData && userData.id) {
          try {
            // Use sendBeacon for more reliable delivery during page unload
            const data = JSON.stringify({ userId: userData.id });
            const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
            navigator.sendBeacon(
              `${baseUrl}/voter/logout`, 
              new Blob([data], { type: 'application/json' })
            );
          } catch (error) {
            console.error("Error in beforeunload:", error);
          }
        }
      }
    };

    // Add event listener
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    // Cleanup listener when component unmounts
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isAuthenticated, auth]);

  const handleLogout = async () => {
    try {
      // Check if we have user data
      if (auth()) {
        const userData = auth();
        // Add null check for userData
        if (userData && userData.id) {
          // Call backend logout endpoint
          await api.post('/voter/logout', { userId: userData.id });
        }
      }
    } catch (error) {
      console.error('Error logging out:', error);
    } finally {
      // Always sign out on the frontend even if backend call fails
      signOut()
      navigate("/", {
        state: { notification: "Logout successful 👋" },
      })
    }
  }

  return (
    <AppBar position="static">
      <Toolbar>
        <Link
          color="inherit"
          to="/"
          style={{ textDecoration: "none", color: "white" }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <img src="/newLogo.jpg" alt="" height="40px" />
            <Typography variant="h6" marginLeft={1}>
              Member Voting
            </Typography>
          </Box>
        </Link>
        <Box flexGrow={1} />
        {isAuthenticated() ? (
          <CustomButton color="inherit" onClick={handleLogout}>
            Logout
          </CustomButton>
        ) : (
          location.pathname !== "/admin/login" && (
            <Button color="inherit" href="/">
              Login
            </Button>
          )
        )}
      </Toolbar>
    </AppBar>
  )
}
